import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import "./App.css";
import { Helmet } from "react-helmet";

// PAGES
import Index from "./component/Index/Index";
import ProdouctCloth from "./component/Prodouctpage/ProdouctCloth";
import Edit from "./component/Profile-Edit/Edit";
import Edit_2 from "./component/Profile-Edit/Edit_2";
import Password from "./component/Create_password/Password";
import Add_Product from "./component/Product_Add/Add_Product";
import Footer from "./component/Footer/Footer";
import Edit_Hello_User from "./component/Profile-Edit/Edit_Hello_User";
import Login_1 from "./component/Login/Login_1";
import Login_open from "./component/Profile-Edit/Login_open";
import Add_click from "./component/Product_Add/Add_click";
import Preview_Ad from "./component/Product_Add/Preview_Ad";
import CategoryPage from "./component/Manu/CategoryPage";
import Login_popup_2 from "./component/Login/Login_popup_2";
import My_ads from "./component/Create_password/My_ads";
import Contact_Us from "./component/Create_password/Contact_Us";
import StickyBottomNav from "./component/StickyBottomNav/StickyBottomNav";
import About from "./component/Footer/QuickLinks/About";
import PrivacyPolicy from "./component/Footer/QuickLinks/PrivacyPolicy";
import Contact from "./component/Footer/QuickLinks/Contact";
import PhoneSlider from "./component/Footer/QuickLinks/PhoneSlider";
import NotFound from "./component/not page/NotFound";
import TestimonialSlider from "./component/Slider/TestimonialSlider";
// import { Helmet } from "react-helmet-async";
import FAQ from "./component/Blog/FAQ";
import CorporateCustomers from "./component/Blog/CorporateCustomers";
import TermsUse from "./component/Blog/TermsUse";
import Calenders from "./component/Prodouctpage/Calenders";
import Download from "./component/Footer/QuickLinks/Download";
import SearchPage from "./component/Header/SearchPage";
import AppAdsTxt from "./pages/AppAdsTxt";
import { Navigate } from "react-router-dom";
function App() {

  useEffect(() => {
    const blockKeys = (e) => {
      if (
        e.key === "F12" ||
        e.key === "PrintScreen" ||
        (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key)) ||
        (e.ctrlKey && e.key === "u")
      ) {
        e.preventDefault();
      }
    };

    const blockRightClick = (e) => e.preventDefault();

    document.addEventListener("keydown", blockKeys);
    document.addEventListener("contextmenu", blockRightClick);

    return () => {
      document.removeEventListener("keydown", blockKeys);
      document.removeEventListener("contextmenu", blockRightClick);
    };
  }, []);

  return (
    <div className="App">
      <Helmet>
        <title>Rentel – Smart Rental App & Rental Marketplace in India</title>

        <meta
          name="description"
          content="Rentel is a smart rental app and rental marketplace in India to rent property, vehicles, electronics and furniture easily."
        />

        <meta name="robots" content="index, follow" />
        <meta name="theme-color" content="#000000" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Rentel – Smart Rental App & Rental Marketplace in India"
        />
        <meta
          property="og:description"
          content="Rentel is a smart rental app and rental marketplace in India to rent property, vehicles, electronics and furniture easily."
        />
        <meta property="og:image" content="/Logo.png" />
        <meta
          name="keywords"
          content="rental app, rental marketplace, rent in india, online rental platform"
        />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://rentel.in" />

        {/* Verification */}
        <meta
          name="google-site-verification"
          content="bW1QHrqchFL0ecE63_KDFUcX2D-2Vx-pPepOA_0H0RY"
        />
      </Helmet>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/:categoryName/:subCategoryName/:productTitle/:productId" element={<ProdouctCloth />} />
        <Route path="/profile-edit" element={<Edit />} />
        <Route path="/My_ads" element={<My_ads />} />
        <Route path="/Edit_2" element={<Edit_2 />} />
        <Route path="/Password" element={<Password />} />
        <Route path="/Add-Product" element={<Add_Product />} />
        <Route path="/Footer" element={<Footer />} />
        <Route path="/Edit_Hello_User" element={<Edit_Hello_User />} />
        <Route path="/login" element={<Login_1 />} />
        <Route path="/Login_open" element={<Login_open />} />
        <Route path="/Preview_Ad" element={<Preview_Ad />} />
        <Route path="/Add_click" element={<Add_click />} />
        <Route path="/Contact_Us" element={<Contact_Us />} />
        <Route path="/Login_popup_2" element={<Login_popup_2 />} />
        <Route path="/StickyBottomNav" element={<StickyBottomNav />} />
        <Route path="/calenders" element={<Calenders />} />
        <Route path="/Add-Product/:category/:subcategory" element={<Add_click />} />
        <Route path="/Add-Product/:category" element={<Add_click />} />
        <Route path="/category/:categoryName" element={<CategoryPage />} />
        <Route path="/category/:categoryName/:subCategoryName" element={<CategoryPage />} />
        <Route path="/PhoneSlider" element={<PhoneSlider />} />
        <Route path="/About" element={<About />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route
          path="/app-ads.txt"
          element={<Navigate to="/ads.txt" replace />}
        />

        <Route
          path="/ads.txt"
          element={<AppAdsTxt />}
        />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/TestimonialSlider" element={<TestimonialSlider />} />
        <Route path="/FAQ" element={<FAQ />} />
        <Route path="/CorporateCustomers" element={<CorporateCustomers />} />
        <Route path="/terms" element={<TermsUse />} />
        <Route path="/Download" element={<Download />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

    </div>
  );
}

export default App;
